import React from 'react';
import AttachmentIcon from '@atlaskit/icon/core/attachment';
import AttachmentIconOld from '@atlaskit/icon/glyph/attachment';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip';
import { fg } from '@atlassian/jira-feature-gating';
import type { ExtraFieldHtml } from '../../../../../../model/extra-fields/types';
import { Container } from '../styled';
import { isDefault, parseContent } from '../utils';
import { Thumbnail } from './thumbnail';

type Props = { field: ExtraFieldHtml };

export function ThumbnailField({ field }: Props) {
	const content = parseContent(field.html);

	if (isDefault(content)) {
		return (
			<Tooltip content={field.label}>
				<Container aria-hidden="true" isDefault={isDefault(content)}>
					{content}
				</Container>
			</Tooltip>
		);
	}

	return (
		<Tooltip content={<Thumbnail label={field.label} content={content} />}>
			{fg('tnk-1620-visual-refresh-software-backlog-icons') ? (
				<AttachmentIcon
					aria-label={field.label}
					LEGACY_fallbackIcon={AttachmentIconOld}
					LEGACY_size="small"
					label=""
					color={token('color.icon')}
				/>
			) : (
				<AttachmentIconOld aria-label={field.label} size="small" label="" />
			)}
		</Tooltip>
	);
}
